import _ from 'lodash'

export function notNullOrZero(value: number | string | null | undefined): boolean {
  const isNull = _.isNull(value)
  let isZero = true

  if (typeof value === 'number') {
    isZero = value === 0
  } else if (typeof value === 'string') {
    const valueAsNumber = Number(value)
    if (_.isNaN(valueAsNumber)) {
      return false
    }

    isZero = valueAsNumber === 0
  }

  return !isNull && !isZero
}
